import { useStore } from 'zustand';
import { BusinessDistance, PrivateDistance } from '../../../types';
import { getStoreByKey } from './store/CarouselStore';
import {
  activeButtonClasses,
  buttonClasses,
  CarouselFieldsEnum,
} from './types/CarouselTypes';

export default function CarouselMileageFilter({ uniqId }: { uniqId: string }) {
  const {
    dispatch,
    selectedBusinessDistance,
    selectedPrivateDistance,
    options,
  } = useStore(getStoreByKey(uniqId));
  if (!options?.fields.includes(CarouselFieldsEnum.SHOW)) return;
  return (
    <>
      {options?.fields?.length &&
      options?.fields?.includes(CarouselFieldsEnum.BUSINESS_LEASE) ? (
        <div className="pb-5">
          <h5 className="px-4 text-sm font-semibold mb-2">Årlig körsträcka</h5>
          <div className="flex gap-2 overflow-x-auto max-w-[100dvw] px-4">
            {Object.values(BusinessDistance).map((distance) => (
              <button
                key={distance}
                className={`${buttonClasses} ${selectedBusinessDistance === distance ? activeButtonClasses : null}`}
                onClick={() =>
                  dispatch({
                    type: 'BUSINESS_DISTANCE',
                    payload: distance,
                  })
                }
              >
                {distance}
              </button>
            ))}
          </div>
        </div>
      ) : null}
      {options?.fields?.length &&
      options?.fields?.includes(CarouselFieldsEnum.PRIVATE_LEASING) ? (
        <div className="pb-5">
          <h5 className="px-4 text-sm font-semibold mb-2">Årlig körsträcka</h5>
          <div className="flex gap-2 overflow-x-auto max-w-[100dvw] px-4">
            {Object.values(PrivateDistance).map((distance) => (
              <button
                key={distance}
                className={`${buttonClasses} ${selectedPrivateDistance === distance ? activeButtonClasses : null}`}
                onClick={() =>
                  dispatch({
                    type: 'PRIVATE_DISTANCE',
                    payload: distance,
                  })
                }
              >
                {distance}
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </>
  );
}
